import React, {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useLocation} from 'react-router-dom'
import {
  Button,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
} from '@material-ui/core'
import IconDownload from 'pages/HealthCenter/Report/Elements/IconDownload.svg'
import Logo from 'pages/HealthCenter/Report/Elements/logo.svg'
import {Locale} from 'components/atoms/TranslationSelect'
import useLanguageReport from 'hooks/useLanguageReport'
import {setLanguage} from 'api/storageApi'
import {getQueryFromUrl} from 'helpers/commonHelper'
import {TYPE_REPORT} from 'pages/Analysis/EEGSummary/constants'
import EEGSummaryReportStyle from 'pages/Analysis/EEGSummary/style'
import FiveIndicatorsReport from 'pages/Analysis/EEGSummary/Report/FiveIndicators'
import BrainFunctionConnectivity from 'pages/Analysis/EEGSummary/Report/BrainFunctionConnectivity'
import BrainFunctionMapping from 'pages/Analysis/EEGSummary/Report/BrainFunctionMapping'

const useStyles = makeStyles(EEGSummaryReportStyle)

function Report() {
  const classes = useStyles()
  const {t, i18n} = useTranslation()

  const location = useLocation()

  const [pathPdf, setPathPdf] = useState<string>('')
  const [isChild, setIsChild] = useState<boolean>(false)
  const [tabActive, setTabActive] = useState(0)
  const [countChangeLang, setCountChangeLang] = useState<number>(0)
  const [currentLocale, setCurrentLocale] = useState<string>(
    i18n.language.toString(),
  )

  const getPathPDF = (path: string) => {
    setPathPdf(path)
  }

  const handleChangeLang = async (value: Locale) => {
    const count = countChangeLang
    setCountChangeLang(count + 1)
    setLanguage(value)
    await i18n.changeLanguage(value)
    setCurrentLocale(value)
  }
  const LANG = [
    {
      label: t('IKoranLang'),
      value: 'ko',
    },
    {
      label: t('IEnglishLang'),
      value: 'en',
    },
    {
      label: t('IJapanesesLang'),
      value: 'ja',
    },
  ]
  const [loadingDownload, setLoadingDownload] = useState(false)
  const handleClickDownLoad = () => {
    setLoadingDownload(true)

    if (pathPdf) {
      // Create a link element
      const link = document.createElement('a')
      const filename = pathPdf.split('/').pop()
      // Set the href attribute to the file URL
      link.href = `${pathPdf}?t=${Date.now()}`
      // Specify the download attribute with the desired file name
      link.download = filename || 'report.pdf'
      // Append the link to the document
      document.body.appendChild(link)
      // Trigger a click event on the link
      link.click()
      // Remove the link from the document
      document.body.removeChild(link)
    }
    setLoadingDownload(false)
  }

  const getNameTab = useMemo(() => {
    if (tabActive === TYPE_REPORT.BRAIN_FUNCTION_MAPPING) {
      if (isChild) {
        return t('IEEGChildSummaryReport')
      }
      return t('IEEGSummaryReport')
    }
    if (tabActive === TYPE_REPORT.FIVE_INDICATORS) {
      return t('IFiveBrainFunctionIndicatorsReport')
    }
    if (tabActive === TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY) {
      return t('IBrainConnectivityReport')
    }
    return ''
  }, [tabActive, i18n.language])

  useEffect(() => {
    const {type} = getQueryFromUrl(location.search)
    setTabActive(type ?? 1)

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [])

  useLanguageReport()

  return (
    <div>
      <div className={classes.root}>
        <div className={classes.topRoot}>
          <div className={`${classes.topNav} no-print`}>
            <div className={classes.topNavLeft}>
              <div className={classes.logo}>
                <img src={Logo} alt='Logo' />
              </div>
              <div className={classes.tabs}>
                <div
                  className={`${classes.tab} ${classes.tabActive}`}
                  aria-hidden='true'
                >
                  {getNameTab}
                </div>
              </div>
            </div>
            <div className={classes.topNavRight}>
              <div>
                <Select
                  value={currentLocale}
                  onChange={(e) => handleChangeLang(e.target.value as Locale)}
                  className={classes.searchSelect}
                  input={<OutlinedInput name='age' id='outlined-age-simple' />}
                >
                  {LANG.map((item) => (
                    <MenuItem value={item.value} key={item.value}>
                      {t(item.label)}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <Button disabled={loadingDownload} onClick={handleClickDownLoad}>
                <img src={IconDownload} alt='IconDownload' />
              </Button>
            </div>
          </div>
          <div id='health-center' className='no-print'>
            {tabActive === TYPE_REPORT.BRAIN_FUNCTION_MAPPING && (
              <BrainFunctionMapping
                setPathPDF={getPathPDF}
                setIsChild={(value: boolean) => {
                  setIsChild(value)
                }}
              />
            )}

            {tabActive === TYPE_REPORT.FIVE_INDICATORS && (
              <FiveIndicatorsReport setPathPDF={getPathPDF} />
            )}
            {tabActive === TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY && (
              <BrainFunctionConnectivity setPathPDF={getPathPDF} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Report
